// extracted by mini-css-extract-plugin
module.exports = {"radioSquareIcon":"Emoji-module__radioSquareIcon___NI8a9"};